import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Lock } from 'lucide-react';
export const PricingSection = () => {
  return <section id="compra" className="py-24 bg-white border-y border-neutral-200 relative overflow-hidden" data-id="element-270">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-271">
        <div className="text-center mb-12" data-id="element-272">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-273">
            Todo lo que recibís hoy:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream rounded-2xl border-2 border-brand-500 shadow-xl overflow-hidden" data-id="element-274">
          <div className="p-8 sm:p-12" data-id="element-275">
            <ul className="space-y-4 mb-8 text-lg sm:text-xl font-medium" data-id="element-276">
              <li className="flex justify-between items-center border-b border-neutral-200 pb-4" data-id="element-277">
                <span className="flex items-center gap-3 text-neutral-900" data-id="element-278">
                  <span className="text-2xl" data-id="element-279">📘</span> Manual Central CAJA DE
                  COBRO
                </span>
                <span className="text-neutral-500 line-through" data-id="element-280">
                  $45.000 ARS
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-4" data-id="element-281">
                <span className="flex items-center gap-3 text-neutral-700" data-id="element-282">
                  <span className="text-2xl" data-id="element-283">🎁</span> Bonus 1: 10 Ganchos de
                  Contenido
                </span>
                <span className="text-neutral-500 line-through" data-id="element-284">
                  $12.000 ARS
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-4" data-id="element-285">
                <span className="flex items-center gap-3 text-neutral-700" data-id="element-286">
                  <span className="text-2xl" data-id="element-287">🎁</span> Bonus 2: Pack 25 Mensajes
                  de Reactivación
                </span>
                <span className="text-neutral-500 line-through" data-id="element-288">
                  $18.000 ARS
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-neutral-200 pb-4" data-id="element-289">
                <span className="flex items-center gap-3 text-neutral-700" data-id="element-290">
                  <span className="text-2xl" data-id="element-291">🎁</span> Bonus 3: Matriz de Oferta
                  Anti-Crisis
                </span>
                <span className="text-neutral-500 line-through" data-id="element-292">
                  $15.000 ARS
                </span>
              </li>
              <li className="flex justify-between items-center pb-4" data-id="element-293">
                <span className="flex items-center gap-3 text-neutral-700" data-id="element-294">
                  <span className="text-2xl" data-id="element-295">🎁</span> Bonus 4: Guion de Cierre
                  Anti "No hay Plata"
                </span>
                <span className="text-neutral-500 line-through" data-id="element-296">
                  $20.000 ARS
                </span>
              </li>
            </ul>

            <div className="bg-white rounded-xl p-6 text-center mb-8 border border-neutral-200 shadow-sm" data-id="element-297">
              <p className="text-neutral-500 font-bold uppercase tracking-wider mb-2" data-id="element-298">
                VALOR TOTAL DEL BUNDLE:
              </p>
              <p className="text-3xl font-bold text-neutral-400 line-through decoration-brand-500/50 decoration-4" data-id="element-299">
                $110.000 ARS
              </p>
            </div>

            <div className="text-center mb-10" data-id="element-300">
              <p className="text-brand-600 font-bold text-xl mb-2 flex items-center justify-center gap-2" data-id="element-301">
                🔥 LO CONSEGUÍS HOY POR:
              </p>
              <p className="text-5xl sm:text-7xl font-bold text-neutral-900 mb-4" data-id="element-302">
                $19.990 ARS
              </p>

              {/* USD Price above button as requested */}
              <div className="inline-block bg-brand-50 border border-brand-200 rounded-full px-4 py-1.5 mb-6" data-id="element-303">
                <p className="text-brand-700 font-bold text-lg" data-id="element-304">
                  Solo $9.97 USD
                </p>
              </div>

              <a href="https://tienda-1-10001.myshopify.com/checkouts/cn/hWNAQr3NwJsa0SuPUCDhl49i/es-ar?_r=AQAB71_6lH8s5n5_3gT2kf8ZrN9yZsImNxSKOxJ4M95T_VM&preview_theme_id=144578674765" target="_blank" rel="noopener noreferrer" className="group relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-brand-600 px-8 py-6 font-sans text-xl sm:text-2xl font-bold text-white shadow-lg transition-all hover:bg-brand-700 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]" data-id="element-305">
                <span className="relative z-10 flex items-center gap-2" data-id="element-306">
                  👇 SÍ, QUIERO MI CAJA DE COBRO AHORA
                </span>
                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" data-id="element-307" />
              </a>

              <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm font-medium text-neutral-600" data-id="element-308">
                <span className="flex items-center gap-1.5" data-id="element-309">
                  <Lock className="h-4 w-4 text-brand-600" data-id="element-310" /> Pago 100% seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-311">
                  <Download className="h-4 w-4 text-brand-600" data-id="element-312" /> Descarga
                  instantánea
                </span>
                <span className="flex items-center gap-1.5" data-id="element-313">
                  <ShieldCheck className="h-4 w-4 text-brand-600" data-id="element-314" /> Garantía 7
                  días
                </span>
              </div>
              <div className="mt-4 flex items-center justify-center gap-2 text-xs text-neutral-500" data-id="element-315">
                🔒 Mercado Pago · Tarjeta Crédito/Débito · Transferencia
                Bancaria
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mt-16 max-w-3xl mx-auto" data-id="element-316">
          <h3 className="text-2xl font-bold text-neutral-900 mb-6 text-center" data-id="element-317">
            Para ponerlo en perspectiva:
          </h3>
          <div className="space-y-6 text-lg text-neutral-700" data-id="element-318">
            <p className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-319">
              Si con este sistema cerrás{' '}
              <strong className="text-brand-600" data-id="element-320">1 solo cliente nuevo</strong>{' '}
              este mes que no hubieras cerrado sin él, la inversión se paga sola
              entre 2 y 10 veces, dependiendo de lo que cobrés.
            </p>
            <p className="bg-cream p-6 rounded-xl border border-neutral-200" data-id="element-321">
              Si reactivás{' '}
              <strong className="text-brand-600" data-id="element-322">1 ex-cliente dormido</strong>{' '}
              con alguno de los 25 mensajes del Bonus 2, ya recuperaste lo
              invertido en las primeras 48 horas.
            </p>
            <p className="text-center text-2xl font-bold text-neutral-900 mt-8" data-id="element-323">
              $19.990 no es el precio de un manual.{' '}
              <span className="text-brand-600" data-id="element-324">
                Es el precio de tu próxima venta.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};